import { FormSection, Link, Timeline } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';

export function HolterConsultationFollowingSteps() {
    const selectedEmploymentId = useSelector((state: IReduxState) => state.authentication.selectedEmploymentId);

    return (
        <FormSection title="Vervolgstappen consult holteronderzoek">
            <Timeline>
                <Timeline.Item>De Ksyos cardioloog ontvangt de consultaanvraag</Timeline.Item>
                <Timeline.Item>
                    Binnen 2 werkdagen na het onderzoek ontvang je de uitslag in het Ksyos platform en via Edifact in je
                    HIS als je je{' '}
                    <Link
                        openInNewTab
                        to={`/employments/${selectedEmploymentId}/personalSettings`}
                        variant="link"
                    >
                        zorgmailnummer hebt doorgegeven
                    </Link>
                </Timeline.Item>
                <Timeline.Item>Optioneel: Je stelt een aanvullende consultvraag aan de cardioloog</Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
